// songbird configurations
export const activeChain = {
  chainId: "0x13", // must be hexadecimal for chainId : 0x10 = 16
  chainName: "Songbird Canary Network",
  nativeCurrency: {
    symbol: "SGB",
    decimals: 18,
  },
  blockExplorerUrls: ["https://songbird-explorer.flare.network/"],
  rpcUrls: ["https://songbird-api.flare.network/ext/C/rpc"],
};
